import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

export function render(_ctx, _cache) {
  const _component_crumbs_p = _resolveComponent("crumbs-p")
  const _component_playground = _resolveComponent("playground")
  const _component_crumbs_button = _resolveComponent("crumbs-button")
  const _component_crumbs_panel = _resolveComponent("crumbs-panel")

  return (_openBlock(), _createElementBlock("div", { class: "app-container" }, [
    _createVNode(_component_crumbs_panel, { "panel-title": "Unlock" }, {
      default: _withCtx(() => [
        _createVNode(_component_crumbs_p, null, {
          default: _withCtx(() => [
            _createTextVNode(" Déplacez le bloc orange à droite de l'écran. ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_playground),
        (_ctx.win)
          ? (_openBlock(), _createElementBlock("div", { key: 0 }, [
              _createVNode(_component_crumbs_p, { style: {"text-align":"center"} }, {
                default: _withCtx(() => [
                  _createTextVNode(" 🎉 C'est gagné pour aujourd'hui ! 🥳 "),
                  _createElementVNode("br"),
                  (!_ctx.indeterminedProgressDone)
                    ? (_openBlock(), _createBlock(_component_crumbs_button, {
                        key: 0,
                        onClick: $event => (_ctx.showGif()),
                        "indeterminate-progress": _ctx.indeterminedProgress,
                        "indeterminate-duration-ms": _ctx.indeterminedDuration,
                        title: "Copier dans le presse-papier"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Afficher le gif ")
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onClick", "indeterminate-progress", "indeterminate-duration-ms"]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.gifUrl && _ctx.indeterminedProgressDone)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        style: {"display":"flex","justify-content":"center","align-items":"center"}
                      }, [
                        _createVNode(_component_crumbs_button, {
                          onClick: $event => (_ctx.share()),
                          title: "Copier dans le presse-papier"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Partager avec le score ")
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _createVNode(_component_crumbs_button, {
                          onClick: $event => (_ctx.scorelessShare()),
                          title: "Copier dans le presse-papier"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Partager ")
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _createElementVNode("img", {
                          src: _ctx.gifUrl,
                          style: {"display":"inline"}
                        }, null, 8 /* PROPS */, ["src"])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true),
        (!_ctx.win)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              style: {"display":"grid","place-content":"center"}
            }, [
              _createVNode(_component_crumbs_p, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Mouvements: " + _toDisplayString(_ctx.moveCount), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_crumbs_button, { onClick: _ctx.clickBack }, {
                default: _withCtx(() => [
                  _createElementVNode("span", { style: {"font-size":"2rem"} }, " Annuler ")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}